import { BaseViewStore } from 'core/stores';
import { QueryUtility } from 'core/utils';
import { action } from 'mobx';

class BaseListViewStore extends BaseViewStore {
	authStore = null;
	listStore = null;
	queryUtility = null;
	routes = null;
	permissions = null;
	tableData = null;

	constructor(
		rootStore,
		{
			listStore,
			routes,
			permissions,
			tableData,
			queryUtility,
			queryParams,
			customSearch = false,
		}
	) {
		super(rootStore);
		this.authStore = rootStore.authStore;
		this.listStore = listStore;
		this.customSearch = customSearch;
		this.queryParams = queryParams;
		this.queryUtility = queryUtility
			? queryUtility
			: new QueryUtility(
					this.rootStore,
					queryParams,
					customSearch
			  );
		this.routes = routes;
		this.permissions = permissions;
		this.tableData = tableData;
	}

	@action.bound setHeaderModes(modes) {
		if (modes) {
			this.rootStore.viewStore.headerSetModes(modes);
		} else {
			this.rootStore.viewStore.headerSetModes();
		}
	}

	@action.bound setSearchVisible(visible = true) {
		if (visible) {
			this.rootStore.viewStore.headerSetSearch(this.queryUtility);
		} else {
			this.rootStore.viewStore.headerSetSearch();
		}
	}

	@action.bound setButtonComponent(buttonComponent) {
		if (buttonComponent) {
			this.rootStore.viewStore.headerSetButton(buttonComponent);
		} else {
			this.rootStore.viewStore.headerSetButton();
		}
	}

	@action.bound setHeaderComponent(component) {
		if (component) {
			this.rootStore.viewStore.headerSetComponent(component);
		} else {
			this.rootStore.viewStore.headerSetComponent();
		}
	}
}

export default BaseListViewStore;



// WEBPACK FOOTER //
// ./src/core/stores/BaseListViewStore.js